module.exports = __webpack_public_path__ + "static/media/5P.19117e03.svg";